<template>
    <div class="corporateCultureBox">
        <aboutBannerVue tabIndex="5"></aboutBannerVue>
        <TypicalAchievement :show-tabs="true" :show-all-tab="true" :show-sidebar="true" />
    </div>
</template>

<script>
import aboutBannerVue from '@/components/aboutBanner'
import TypicalAchievement from '@/components/TypicalAchievement.vue'

export default {
    name: 'CorporateCulture',
    components: { aboutBannerVue, TypicalAchievement }
}
</script>

<style scoped>
.corporateCultureBox {
    padding-bottom: 30px;
}
</style>
